import React, { useState, useEffect, useCallback } from 'react';
import { Row, Col, Spin } from 'antd';
import { ListDocuments } from '../listDocuments';
import { useCookies } from 'react-cookie';
import { Dropbox } from 'dropbox';
import DPLOGOIMAGE from '../assets/images/dp-logo.png';
import '@fontsource/noto-sans';
import 'antd/dist/reset.css';
import './App.css';
import { ISelectSourcepProps } from './selectSource.types';

const dropbox_url = 'https://dropboxplugin.netlify.app';

const CLIENT_ID=process.env.REACT_APP_CLIENT_ID

export const SelectSource = (props: ISelectSourcepProps) => {

  const { getDropboxFileData } = props;

  const [cookies, setCookie, removeCookie] = useCookies();
  const [listDocumentsVisible, setListDocumentsVisibility] = useState(false);
  const [rootId, setRootId] = useState('');
  const [isLoadingGoogleDriveApi, setIsLoadingGoogleDriveApi] = useState(false);
  const [signedInUser, setSignedInUser] = useState();
  const [accountId, setAccountId] = useState({});
  const [authUrl, setAuthUrl] = useState('');
  const [accessToken, setAccessToken] = useState('');

  /**
   *  Called when the signed in status changes, to update the UI
   *  appropriately. After a sign-in, the API is called.
   */

  // replace it with refresh token logic
  useEffect(() => {
    if (!cookies.dUser) {
      // /initClient();
    }
  }, [rootId, signedInUser]);

  /**
   *  Sign out the user upon button click.
   */
  const handleSignOutClick = () => {
    removeCookie('dUser');
    window.location.assign(dropbox_url);
    //@ts-ignore
    setSignedInUser();
  };

  useEffect(() => {
    const setAuthLink = async () => {
      const dbx: any = new Dropbox({ clientId: CLIENT_ID });
      const authLink = await dbx.auth.getAuthenticationUrl(dropbox_url);
      setAuthUrl(authLink);
    };
    if (!authUrl) {
      setAuthLink();
    }
  }, [authUrl]);

  const getJsonFromUrl = (str : any) => {
    const query = str.substr(1);
    const result = {};

    query.split('&').forEach((part : any) => {
      const item = part.split('=');
      //@ts-ignore
      result[item[0]] = decodeURIComponent(item[1]);
    });

    return result;
  };

  useEffect(() => {
    if (!accessToken) {
      const result: any = getJsonFromUrl(window.location.hash);
    
      if (!result.access_token) {
        return;
      }
     
      setAccessToken(result.access_token);
     
      setAccountId(result.account_id);
    
      document.cookie = `dUser=${result.access_token}`;
      //@ts-ignore
      setSignedInUser(true);
    }
  }, [accessToken, signedInUser]);

  const onClose = () => {
    setListDocumentsVisibility(false);
  };

  const signInUpdate = useCallback(() => {
    //@ts-ignore
    setSignedInUser(true);
  }, [signedInUser]);

  return (
    <div className='google-drive-plugin'>
      {signedInUser || cookies.dUser ? (
        <ListDocuments
          rootId={rootId}
          token={accessToken}
          onSignOut={handleSignOutClick}
          signInUpdate={signInUpdate}
          getDropboxFileData={getDropboxFileData}
        />
      ) : (
        <div>
          <Spin spinning={isLoadingGoogleDriveApi} style={{ width: '100%' }}>
            <div className="source-container" style={{ paddingTop: '35%' }}>
              <div className="content-container">
                <span className="content, get-started">Get started by connecting your account</span>
              </div>
              <div className="icon-container" style={{ paddingTop: '40px' }}>
                <div className="icon icon-success">
                  <img height="148" width="224" src={DPLOGOIMAGE} />
                </div>
              </div>
              <div className={'content-container'} style={{ paddingTop: '50px' }}>
                <a href={authUrl}>
                  <button className={'connect-button'}>Connect</button>
                </a>
              </div>
            </div>
          </Spin>
        </div>
      )}
    </div>
  );
};